import { useCallback, useEffect, useRef } from 'react';

// Exporte une fonction fetch qui s'auto annule lors du démontage
export function useFetch() {
    const abortController = useRef(new AbortController());
    useEffect(() => () => abortController.current.abort(), []);

    return useCallback((url, options) => fetch(url, { signal: abortController.current.signal, ...options }), []);
}
